/**
 * Staff are recognised by their address, which is the only signal every caller
 * of the resolver already holds — the dashboard, a Nest guard and the render
 * path all carry the account's email, and none of them share a roles table.
 *
 * `packages/prerender-shared/src/cf-beta-access.ts` holds the same suffix for
 * the Cloudflare beta. Wiring that feature through this package is what removes
 * the second copy; until then, changing one means changing both.
 */
export const PRERENDER_EMAIL_SUFFIX = '@prerender.io';

export function isStaffEmail(email: string | null | undefined): boolean {
  return email?.toLowerCase().endsWith(PRERENDER_EMAIL_SUFFIX) ?? false;
}
